<template>
  <div
    class="tw:bg-white tw:flex tw:flex-col tw:border-t tw:md:border tw:border-gray-300 tw:md:rounded-xl tw:md:p-4 tw:py-10"
  >
    <div v-if="logo" class="tw:mb-3">
      <img :src="logo" :alt="productName" class="tw:h-[23px]" />
    </div>
    <h1 class="tw:font-bold tw:text-gray-800 tw:text-xl tw:mb-3">{{ header }}</h1>
    <slot />
  </div>
</template>
<script setup>
defineProps({
  logo: [String, URL],
  productName: String,
  header: String,
})
</script>
